export default "__VITE_ASSET__njbyTtJO__"